export default [
  {
    path: '/',
    component: () => import('@/layouts/PortalLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/portal/Home.vue'),
        meta: { title: '首页', portalIndex: '01' }
      },
      {
        path: 'articles',
        name: 'Articles',
        component: () => import('@/views/portal/Articles.vue'),
        meta: {
          title: '文章',
          portalIndex: '02',
          seoDescriptionKey: 'articles',
          viewKey: 'articles'
        }
      },
      {
        path: 'notes',
        name: 'Notes',
        component: () => import('@/views/portal/Notes.vue'),
        meta: { title: '简言', portalIndex: '03', seoDescriptionKey: 'notes' }
      },
      {
        path: 'category/:id',
        name: 'Category',
        component: () => import('@/views/portal/Articles.vue'),
        meta: {
          title: '分类',
          portalIndex: '02',
          seoDescriptionKey: 'articles',
          viewKey: 'articles'
        }
      },
      {
        path: 'tag/:name',
        name: 'Tag',
        component: () => import('@/views/portal/Articles.vue'),
        meta: {
          title: '标签',
          portalIndex: '02',
          seoDescriptionKey: 'articles',
          viewKey: 'articles'
        }
      },
      {
        path: 'archives',
        name: 'Archives',
        component: () => import('@/views/portal/Archives.vue'),
        meta: { title: '归档', portalIndex: '04', seoDescriptionKey: 'archives' }
      },
      {
        path: 'links',
        name: 'Links',
        component: () => import('@/views/portal/Links.vue'),
        meta: { title: '友链', seoDescriptionKey: 'links' }
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/views/portal/About.vue'),
        meta: { title: '关于', portalIndex: '05', seoDescriptionKey: 'about' }
      },
      {
        path: '404',
        name: 'PortalNotFound',
        component: () => import('@/views/portal/NotFound.vue'),
        meta: { title: '页面未找到' }
      },
      {
        path: ':id',
        name: 'ArticleDetail',
        component: () => import('@/views/portal/ArticleDetail.vue'),
        meta: { title: '文章详情', portalIndex: '02' }
      },
      { path: ':pathMatch(.*)*', redirect: { name: 'PortalNotFound' } }
    ]
  }
]
